/**
 * Canvas-space position along a guide's axis for a client point over the scroller: Y for a
 * horizontal guide, X for a vertical one. `originX`/`originY` come from `getCanvasOrigin()`.
 */
export function computeGuidePositionAtClient(
  scroller: HTMLElement,
  origin: { originX: number; originY: number },
  type: 'horizontal' | 'vertical',
  clientX: number,
  clientY: number,
  scale: number
): number {
  const rect = scroller.getBoundingClientRect()

  return type === 'horizontal'
    ? (clientY - rect.top + scroller.scrollTop - origin.originY) / scale
    : (clientX - rect.left + scroller.scrollLeft - origin.originX) / scale
}
